$.fn.responsiveEqualHeights = function(rowName, equalHeightBlock) {
    'use strict';
    var $list       = $( this ),
        $items      = $list.find( rowName ),
        $itemsH     = $list.find( equalHeightBlock ),

        setHeights  = function() {
            $itemsH.css( 'height', 'auto' );

            var perRow = Math.floor( $list.width() / $items.width() );
            if( perRow == null || perRow < 2 ) return true;

            for( var i = 0, j = $items.length; i < j; i += perRow )
            {
                var maxHeightH   = 0,
                    $rowH        = $itemsH.slice( i, i + perRow);

                $rowH.each( function()
                {
                    var itemHeightH = parseInt( $( this ).outerHeight() );
                    if ( itemHeightH > maxHeightH ) maxHeightH = itemHeightH;
                });
                $rowH.css( 'height', maxHeightH );
            }
        };

    setHeights();
    jQuery( window ).load(function() {setHeights()});
    jQuery( window ).on( 'resize', setHeights );
};